import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../axiosAuth";
import { SCHOOL_INVENTORY_DETAIL_CREATE } from "./apiRoutes";
import { removeEmptyFields } from "@/lib/utils";

export interface CreateSchoolInventoryDetailPayload {
  schoolId: string;
  isTvIncluded?: boolean;
  is3DPrinterIncluded?: boolean;
  isElectricalIncluded?: boolean;
  isStorageCabinetsIncluded?: boolean;
  isTeachersTableIncluded?: boolean;
  isPodiumIncluded?: boolean;
  isTabletsIncluded?: boolean;
  isChairsIncluded?: boolean;
  isPaintingIncluded?: boolean;
  infrastructureNotes?: string | null;
  curriculumNotes?: string | null;
  otherNotes?: string | null;
}

export interface CreateSchoolInventoryDetailResponse {
  data?: unknown;
  message?: string;
}

export const useCreateSchoolInventoryDetailMutation = (options?: { onSuccess?: () => void }) => {
  return useMutation({
    mutationFn: async (payload: CreateSchoolInventoryDetailPayload) => {
      const response = await axiosAuth.post<CreateSchoolInventoryDetailResponse>(
        SCHOOL_INVENTORY_DETAIL_CREATE,
        removeEmptyFields(payload)
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Inventory details saved successfully");
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.issues?.message || error?.response?.data?.message || "Failed to save inventory details";
      toast.error(message);
    },
  });
};


